<template>
  <form
    method="post"
    action=""
    class="form-group mt-5"
    @submit.prevent="onSubmit"
    @keydown="formRef.errors.clear($event.target.name)"
  >
    <div id="loader" v-if="loading">
      <div class="spinner"></div>
    </div>

    <div class="alert alert-success" role="alert" v-if="answer">
      {{ answer }}
    </div>
    <div class="alert alert-warning" role="alert" aria-live="assertive" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="col-sm-8" v-if="linkExpired">
      <h1>Whoops! Your password link has expired.</h1>

      <p>
        It looks like your password rest link has expired (our links expire
        after a few hours for your security). Nothing to worry about! Hit the
        re-send email button below and we’ll send a new password reset link to
        your email address.
      </p>

      <div>
        <button class="btn bl-button btn-primary" :disabled="formRef.errors.any()">
          <span class="bl-submit-text">Re-send email</span>
        </button>
      </div>
    </div>
    <div v-else-if="answer.value" class="row">
      <div class="col-sm-8 back-link">
        <a href="/login">Take me to login</a>
      </div>
    </div>
    <div v-else>
      <div>
        <h1>Reset password</h1>

        <p>
          Submit your email address below and we’ll send you instructions on how
          create a new password.
        </p>

        <div class="form-group">
          <label class="form-label" for="email">Email address</label>
          <input
            type="text"
            class="form-control"
            id="email"
            name="email"
            v-model="formRef.email"
          />
        </div>

        <button
          class="btn bl-button btn-primary mb-3"
          :disabled="formRef.errors.any()"
        >
          <span class="bl-submit-text">Reset password</span>
        </button>

        <div>
          <a href="/login">Take me back to login</a>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import Form from "../Form.js";
import { ref, markRaw, onMounted } from "vue";

const errorMessage = ref('')
const loading = ref(false)  
const linkExpired = ref(null)  
const answer = ref('')
      
onMounted(() => {
  if (window.linkExpired) {
    return linkExpired.value = "expired";
  }
})

let formRef = markRaw(ref(new Form({
  email: ""
})))

function onSubmit() {
  errorMessage.value = "";
  answer.value = "";

  if (linkExpired.value) {
    formRef.value.email = emailOrigin;
  }
  if (!formRef.value.email) {
    return (errorMessage.value = "Please enter an email address.");
  }
  (loading.value = true),
    formRef.value
      .post("/forgot-password")
      .then(
        (response) => (
          (loading.value = false),
          (errorMessage.value = response["errors"]),
          (answer.value = response["results"]["answer"])
        )
      );
}
</script>
